(function($) {
  $(function() {
    function syncCheckoutButtonState() {
      var checked = $('[data-b2b-confirmation-checkbox]').is(':checked');
      $('[data-b2b-checkout-button]').prop('disabled', !checked);
    }

    // Exemptify
    $('[id^="tab"]').on('change', function() {
      // Reset values on tab change
      $('#de-vat-id, #VatId').val('').removeAttr('aria-invalid');
      $('#de-vat-id-error').hide();
    });

    $(document).on('change input', '[data-b2b-confirmation-checkbox]', function() {
      syncCheckoutButtonState();
    });

    $(document).on('click', '[name^="checkout"]', function(e) {
      if(!window.theme.loggedIn) {
        // Reset validation
        $('#de-vat-id, #VatId').removeAttr('aria-invalid');
        $('#de-vat-id-error').hide();

        var deVatIdValid = !!$('#de-vat-id').val() && /^DE\d{9}$/.test($('#de-vat-id').val().replace(/\s/g, ''));
        var euVatIdValid = !!$('#VatId').val();

        if(!deVatIdValid) {
          $('#de-vat-id').attr('aria-invalid', true);
          $('#de-vat-id-error').show();

          if(!euVatIdValid) {
            $('#VatId').attr('aria-invalid', true);
            e.preventDefault();
          }
        }
      }

      if (!$('[data-b2b-confirmation-checkbox]').is(':checked')) {
        $('[data-b2b-confirmation-error]').prop('hidden', false);
        e.preventDefault();
        return;
      } else {
        $('[data-b2b-confirmation-error]').prop('hidden', true);
      }
    });

    syncCheckoutButtonState();
  });
})(jQuery);